import * as stylex from "@stylexjs/stylex";
import { Alert, Button } from "@softmax/design-system";
import { composerStyles } from "../forum-composer.styles";
import type { ForumImageShare } from "../forum.types";
export function ForumPostImageShare({
  shareImage,
}: Readonly<{
  shareImage: ForumImageShare;
}>) {
  return (
    <div {...stylex.props(composerStyles.form)}>
      <div {...stylex.props(composerStyles.actions)}>
        <Button
          size="sm"
          aria-disabled={
            shareImage.status === "copying" ||
            shareImage.status === "downloading"
          }
          onClick={() => shareImage.onShare("copy-image")}
        >
          {shareImage.status === "copying"
            ? "Copying image…"
            : shareImage.status === "copied"
              ? "Image copied"
              : "Copy image"}
        </Button>
        <Button
          size="sm"
          aria-disabled={
            shareImage.status === "copying" ||
            shareImage.status === "downloading"
          }
          onClick={() => shareImage.onShare("download-image")}
        >
          {shareImage.status === "downloading"
            ? "Downloading image…"
            : shareImage.status === "downloaded"
              ? "Image downloaded"
              : "Download image"}
        </Button>
      </div>
      {shareImage.error && (
        <Alert tone="danger" announcement="assertive">
          {shareImage.error}
        </Alert>
      )}
    </div>
  );
}
